import * as React from 'react';
import { useSelector } from 'react-redux';

import { localeData } from '../../../locales/data';
import { alphaListFetchingInnerCorrelationSelector } from '../../../reducers/AlphaListsReducer/AlphaListsSelector';
import { addModifiers } from '../../../shared/helpers';
import ChartContainer from '../../AlphaChart/ChartContainer';

import './InnerChartContainer.scss';
import { FormattedMessageHelper } from '../../../shared/helpers/internationalization';

interface InnerChartContainerProps {
  alphasInfo: any;
}

const InnerChartContainer = (props: InnerChartContainerProps) => {
  const { alphasInfo } = props;
  // @ts-ignore
  const isFetchingInnerCorrelation = useSelector(alphaListFetchingInnerCorrelationSelector);

  // Returns array of ids from the props.alphasInfo
  const getAlphasInfoID = () => {
    let alphasID = [];
    if (alphasInfo) {
      alphasID = alphasInfo.map((alpha: any) => alpha.id);
    }

    return alphasID;
  };

  if (alphasInfo && !isFetchingInnerCorrelation) {
    return (
      <div className="alphas-comparison__chart">
        <div className={addModifiers('alphas-comparison__title', ['chart'])}>
          <FormattedMessageHelper
            tagName="span"
            id="alphasComparisonMain.comparisonChart"
            defaultMessage={localeData.en['alphasComparisonMain.comparisonChart']}
          />
        </div>
        <div className="alphas-comparison__chart-body">
          <div className="alphas-comparison__chart-highstock">
            <ChartContainer
              path={['tags', 'lists', 'innerCorrelationData']}
              pathNoneAllButtons={['alphas']}
              id="alphas-list-chart"
              position="odd"
              filterChartData={getAlphasInfoID()}
              noResults="chart.noResults"
            />
          </div>
        </div>
      </div>
    );
  } else {
    return null;
  }
};

export default InnerChartContainer;
